const mesManagement = {
    path: 'mesManagement',
    component: resolve => require(['@/pages/admin/message/mesManagement.vue'], resolve)
}

export default mesManagement